import React, { useState, useEffect } from 'react';
import { TextField, Button, Box, Typography, Tooltip, IconButton} from '@mui/material';
import Header1 from '../Header/Header1';
import Footer2 from '../Footer/Footer2';
import Header from '../Header/Header';
import { useAuth } from '../../AuthContext';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';


const API_URL = process.env.REACT_APP_API_URL;

function CustomerSupport({ onLogout }) {
  const { userId } = useAuth();
  const [query, setQuery] = useState('');
  const [emailOrPhone, setEmailOrPhone] = useState(''); // Track email or phone
  const [responseMessage, setResponseMessage] = useState('');

  useEffect(() => {
          window.scrollTo(0, 0);  // Scroll to top when this page is loaded
      }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!query) {
      setResponseMessage('Please enter a query.');
      return;
    }

    // If the user is not logged in, ensure that they provide an email or phone
    if (!userId && !emailOrPhone) {
      setResponseMessage('Please provide your email or contact number.');
      return;
    }

    // Prepare the data to send to the backend
    const requestData = { query, ...(userId ? {} : { contact: emailOrPhone }) };

    // Send query to the backend (Django)
    try {
      const response = await fetch(`${API_URL}/create_support_query/?user_id=${userId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      const result = await response.json();
      if (response.ok) {
        setResponseMessage('Your query has been submitted successfully!');
        setQuery('');
        setEmailOrPhone(''); // Clear email/phone input when query is successful
      } else {
        setResponseMessage(result.message || 'An error occurred.');
      }
    } catch (error) {
      setResponseMessage('An error occurred while submitting the query.');
    }
  };

  

  return (
    <div>
      {userId ? (
        <Header1 style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', alignItems: 'center' }} userId={userId} onLogout={onLogout} />
      ) : (
        <Header style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', alignItems: 'center' }} />
      )}

      <Box sx={{ maxWidth: '600px', margin: '0 auto', padding: 3, mt: 10, minHeight: '100vh', letterSpacing: 7 }}>
        <Typography component="h1" variant="h4" sx={{ mb: 2, textAlign: 'center' }}>
          Customer Support
        </Typography>

        {!userId && (
          <TextField
            label="Enter your email or contact number"
            fullWidth
            value={emailOrPhone}
            onChange={(e) => setEmailOrPhone(e.target.value)}
            sx={{
              mb: 2,
              letterSpacing: 4,
              color: 'white', // Text inside the input field
              backgroundColor: 'black',
              mt: 3,
              '& .MuiInputLabel-root': {
                color: 'white', // Make label text white
                letterSpacing: 4,
              },
              '& .MuiInputBase-input': {
                color: 'white', // Text inside the input field
                letterSpacing: 4,
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'white', // Optional: Change the border color to white
                letterSpacing: 4,
              },
            }}
          />
        )}

        <TextField
          label="Enter your query"
          fullWidth
          multiline
          rows={4}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          sx={{
            mb: 2,
            color: 'white', // Text inside the input field
            backgroundColor: 'black',
            mt: 3,
            letterSpacing: 4,
            '& .MuiInputLabel-root': {
              color: 'white', // Make label text white
              letterSpacing: 4,
            },
            '& .MuiInputBase-input': {
              color: 'white', // Text inside the input field
              letterSpacing: 4,
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'white', // Optional: Change the border color to white
              letterSpacing: 4,
            },
          }}
        />

        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          sx={{ width: '100%', mt: 2, mb: 5, letterSpacing: 5 }}
        >
          Submit Query
        </Button>

        {responseMessage && (
          <Typography variant="body1" sx={{ mt: 2, color: '#0077ff', letterSpacing: 4}}>
            {responseMessage}
          </Typography>
        )}
      </Box>

      <Tooltip title="Scroll to Top" placement="top">
      
              <IconButton
                onClick={scrollToTop}
                sx={{
                  position: 'fixed', bottom: 16, right: 16, backgroundColor: 'white', color: 'black', "&:hover": {
                    color: "#1E90FF",  // Icon color on hover
                  },
                }}
              >
                <ArrowUpwardIcon />
              </IconButton>
            </Tooltip>

      <Footer2 />
    </div>
  );
}

export default CustomerSupport;
